export default __webpack_public_path__ + "static/media/Polygon39.c9545f35.svg";